<ng-container>
  @if (isCreditScoreAvailable) {
    <div (click)="emitCreditManagerClick()" class="tu-score-card">
      <a class="score-header">
        <span>Credit Manager</span>
        <app-icon-arrow
          [width]="'20'"
          [height]="'20'"
        ></app-icon-arrow>
      </a>
      <svg
        viewBox="0 0 36 36"
        class="tu-score-svg excellent"
        xmlns="http://www.w3.org/2000/svg"
        >
        <g class="tu-score-ranges">
          <path
            class="tu-score-rail blank"
            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
          ></path>
          <path
            class="tu-score-rail very-bad"
            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
          ></path>
          <path
            class="tu-score-rail bad"
            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
          ></path>
          <path
            class="tu-score-rail fair"
            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
          ></path>
          <path
            class="tu-score-rail good"
            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
          ></path>
          <path
            class="tu-score-rail excellent"
            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
          ></path>
          @if (vantageScoreRating.rating !== 'unknown') {
            <g
              class="tu-score-pointer"
              #scorePointer
              >
              <g class="g-circle">
                <circle
                  class="circle"
                  cx="19"
                  cy="2.2"
                  r="1.5"
                  stroke-width="0.5"
                  fill="#fff"
                ></circle>
                <g class="g-within-circle"></g>
              </g>
              <g class="g-circle">
                <circle
                  class="circle-level"
                  #scorePointerColor
                  cx="19"
                  cy="2.1"
                  r="1"
                  stroke-width="0.3"
                ></circle>
              </g>
            </g>
          }
        </g>
        <text x="0" y="36" class="min min-max-score">300</text>
        <text x="23" y="36" class="max min-max-score">850</text>
      </svg>
      <div class="tu-score-text">
        <div class="tu-score-number">
          <div class="tu-score">
            {{ (vantageScore !== null) ? vantageScore : '?' }}
          </div>
        </div>
        <div class="score-type">
          {{ (vantageScore !== null) ? '' : 'Your credit score' }}
        </div>
        <div class="tu-score-level" #scoreRating>
          {{
          (vantageScore !== null) ? (vantageScoreRating?.rating | uppercase) : ''
          }}
        </div>
        <div class="tu-score-description">
          <p class="tu-score-description-line">VantageScore® 3.0 by TransUnion®</p>
        </div>
      </div>
    </div>
  } @else {
    <div class="inactive-content" (click)="emitCreditManagerClick()">
      <div class="img-container">
        <img
          src="../../../../../assets/images/credit-manager-bg.webp"
          alt="credit manager graphic"
          class="credit-manager-img"
          >
        </div>
        <div class="text-container">
          <p class="heading"> Take your credit confidence to the next level </p>
          <ul class="list">
            <li>
              <span>Weekly score updates</span>
            </li>
            <li>
              <span>Credit monitoring alerts</span>
            </li>
            <li>
              <span>In-depth score analysis</span>
            </li>
          </ul>
          <button class="get-credit-btn be-btn--ghost" data-test-id="customer-hub-credit-score-button">Get my credit score</button>
        </div>
      </div>
    }
  </ng-container>
